import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class DeviceWideTaskResultDeviceAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'deviceWideTaskResultDevice';

	getByScanId(scanid) {
		let request = {
			url: [this.getAPIUrl(), 'scanid', scanid].join('/'),
		};

		return httpClient.getAsync(request);
	}
}

export default new DeviceWideTaskResultDeviceAPI();
